import { SKELETON_ITEMS } from '../../../../constants'
import { Placeholder } from '../../../shared/ReactBootstrap'
import TimerBar from '../TimeBar/TimerBar'

interface SlideInfoSkeletonProps {
  id: string
  duration: number
  pause: boolean
  activeItem?: string
}

const SlideInfoSkeleton = ({ id, duration, pause, activeItem }: SlideInfoSkeletonProps) => {
  return (
    <div className='carousel-sidebar-slide-info'>
      {id === activeItem ? (
        <div className='carousel-item-info-container'>
          <TimerBar isActive={true} duration={duration} pause={pause} />
          <div className='carousel-item-info'>
            <Placeholder className='header' xs={12} />
            <Placeholder className='heading-description' xs={12} />
            <div className='bullet-list'>
              {SKELETON_ITEMS.map((bullet: string) => {
                return (
                  <div className='bullet-list-item' key={JSON.stringify(bullet)} style={{ minWidth: '35vw' }}>
                    <div className='bullet-icon icon-placeholder' />
                    <Placeholder className='bullet-text' xs={8} />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      ) : (
        <div className='carousel-item-info-container'>
          <TimerBar isActive={false} duration={duration} pause={pause} />
          <div className='carousel-item-info'>
            <Placeholder className='header inactive' xs={12} />
          </div>
        </div>
      )}
    </div>
  )
}

export default SlideInfoSkeleton
